/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const timeLineDataSetSchema = z.object({
  deletedInItemStore: z.boolean(),
  itemId: z.int(),
  matched: z.boolean(),
  parentId: z.int().nullish(),
});
